/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuHoursAssociationsBulkDeleteInput } from '../../models/menu-hours-associations-bulk-delete-input';
import { MenuHoursAssociationsBulkResult } from '../../models/menu-hours-associations-bulk-result';

export interface MenuHoursGroupAssociationsBulkDelete$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
  hoursId: string;
      body: MenuHoursAssociationsBulkDeleteInput
}

export function menuHoursGroupAssociationsBulkDelete(http: HttpClient, rootUrl: string, params: MenuHoursGroupAssociationsBulkDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuHoursAssociationsBulkResult>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupAssociationsBulkDelete.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.path('hoursId', params.hoursId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuHoursAssociationsBulkResult>;
    })
  );
}

menuHoursGroupAssociationsBulkDelete.PATH = '/menus/{menuId}/hours/{hoursId}/associations/bulk-delete';
